import {
  default as MUITabs,
  TabsProps as MUITabsProps,
} from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';
import { ChangeEvent, FC, useCallback, useContext } from 'react';
import { ActiveTabContext } from './TabsContainer';

type TabsProps = {
  onTabChange?: (e: ChangeEvent, value: any) => void;
} & MUITabsProps;

export const StyledTabs = styled(MUITabs)(() => ({
  minHeight: '40px',
  '&.MuiTabs-scrollButtons': {
    width: 'auto',
  },
}));

// In order to handle state manually, value and onChange has to be passed
const Tabs: FC<TabsProps> = ({
  indicatorColor = 'primary',
  className,
  classes = {},
  value,
  children,
  onTabChange,
  ...restTabsProps
}): JSX.Element => {
  const { activeTab, handleTabChange } = useContext(ActiveTabContext);

  const handleChange = useCallback(
    (event: ChangeEvent, newActiveTab: number) => {
      handleTabChange && handleTabChange(newActiveTab);
      onTabChange && onTabChange(event, newActiveTab);
    },
    [onTabChange, handleTabChange],
  );

  return (
    <StyledTabs
      className={className}
      onChange={onTabChange || handleChange}
      value={activeTab || value}
      indicatorColor={indicatorColor}
      classes={classes}
      {...restTabsProps}
    >
      {children}
    </StyledTabs>
  );
};
export default Tabs;
